import { Entity, MicroMClient } from "@mcurros2/microm";
import { DatosServiciosAutorizacionFiltersDef } from "./DatosServiciosAutorizacionFiltersDef";


export class DatosServiciosAutorizacionFilters extends Entity<DatosServiciosAutorizacionFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DatosServiciosAutorizacionFiltersDef(), parentKeys);
        this.Form = import('./DatosServiciosAutorizacionFiltersForm').then((module) => module.DatosServiciosFiltersForms);
        this.Title = "Filtros de Datos Servicios";
    }
}